const HOME = { title: 'Início', url: ['/'], key: 0 };
const STORES = { title: 'Restaurantes', url: ['/restaurantes'], key: 1 };
const COUPON = { title: 'Cupons', url: ['/cupom'], key: 2 };
const DELIVERY = { title: 'Delivery', url: ['/?openDelivery=true'], key: 3 };
const MORE = { title: 'Mais', url: ['#'], key: 4 };
const LOGIN = {
  title: 'Entrar',
  url: ['/onboarding', '/login', '/verificar'],
  key: 5,
};
export default [HOME, STORES, COUPON, DELIVERY, MORE, LOGIN];
